<template>
  <ConfirmDialog></ConfirmDialog>
  <div class="calendar card">
    <div class="calendar-header flex justify-content-between">
      <div class="col-6">
        <h3>{{ currentMonth() }}</h3>
      </div>
      <div class="col-6 flex justify-content-end">
        <Calendar v-model="currentDate" view="month" dateFormat="mm/yy" class="p-input-xl h-full" @date-select="updateCalendarGrid"/>
        <Button class="h-full ml-1" icon="pi pi-chevron-left" @click="prevMonth"/>
        <Button class="h-full ml-1" icon="pi pi-chevron-right" @click="nextMonth"/>
        <Button v-if="isAdministradorMantenimientos()" class="h-full ml-1" icon="pi pi-plus" label="Nuevo" @click="agregarEvento(null)"/>
      </div>
    </div>
        <div class="header-week-container">
          <div class="header-day-container" v-for="day in daysOfWeek" :key="day"><h5 class="text-center py-2 m-0">{{ day }}</h5></div>
        </div>
        <div class="week-container" v-for="(week, index) in calendarGrid" :key="index">
          <div class="day-container flex align-items-start justify-content-start" v-for="(day, dayIndex) in week" :key="dayIndex">
              <div class="p-grid w-full px-2 ">
                <div class="col-12 flex justify-content-start pl-0">
                    <Badge class="cursor-pointer border-circle" @click="agregarEvento(getDateFromMonth(day))" :value="day" :class="{'p-badge-success': isToday(day)}" size="large"></Badge>
                </div>
                <ScrollPanel style="width: 100%; height: 11rem" :pt="{content: { class: 'p-0' }, barY : { class: 'hidden' }}">
                    <div v-for="mantenimiento in obtenerMantenimientosDelDia(day)" :key="mantenimiento.Id_mantenimiento" @click="modificarEvento(mantenimiento)" class="col-12 mb-3 cursor-pointer grid max-h-6rem white-space-nowrap overflow-scroll no-scrollbar" :class="estatus[mantenimiento.Id_estatus]">
                        <div class="col-12 py-1" v-for="u in mantenimiento.unidades" :key="u.Unidad">
                          <span v-if="u.Descripcion_CC"> {{ u.Descripcion_CC }}</span>
                          <span v-else>{{ u.Unidad }}</span>
                        </div>
                    </div>
                </ScrollPanel>
              </div>
          </div>
        </div>
  </div>
  <!-- Dialogo de nuevo evento -->
  <Dialog
    :style="{ width: '50%' }"
    :visible="showAgregar"
    :modal="true"
    class="p-fluid"
    :closable="false"
  >
    <template #header>
      <div class="grid w-full">
        <div class="col-10">
          <h3>{{ modoEdicion }} mantenimiento</h3> 
        </div>
        <div class="col-2 flex justify-content-end" v-if="objEvent.Id_estatus != 12 && typeof objEvent.Id_mantenimiento != 'undefined' && isAdministradorMantenimientos()">
          <Button icon="pi pi-trash" class="p-button-danger" @click="eliminarMantenimiento" />
        </div>
      </div>
    </template>

      <TabView v-model:activeIndex="active" @update:activeIndex="tabChange">
        <TabPanel header="Mantenimiento">
          <BlockUI :blocked="objEvent.Id_estatus == 12" > 
            <div class="grid">
                <div class="field col-4">
                  <label class="font-bold" for="Fecha">Fecha</label>
                  <Calendar
                    id="Fecha"
                    v-model="objEvent.Fecha_mantenimiento"
                    required="true"
                    dateFormat="dd/mm/yy"
                    :class="{ 'p-invalid': submitted && !objEvent.Fecha_mantenimiento }"
                    :disabled="disabledDate"
                  />
                  <small class="p-error" v-if="submitted && !objEvent.Fecha_mantenimiento"
                    >Este campo es requerido.</small
                  >
                </div>
                <div class="col-8 grid">
                  <div class="col-12 field">
                    <label class="font-bold" for="Unidades">Unidades</label>
                    <MultiSelect v-model="objEvent.unidades" :options="unidades" optionLabel="Unidad" placeholder="Seleccionar unidades" display="chip" class="w-full" id="Unidades" :filter="true" dataKey="UI"
                    :class="{ 'p-invalid': submitted && ((objEvent.unidades && objEvent.unidades.length == 0) || !objEvent.unidades) }"
                    :disabled="objEvent.Id_estatus == 12"
                    :filterFields="['UI','Unidad']"
                    @change="verificarUnidades"
                    >
                        <template #option="slotProps">
                            <div class="flex align-items-center">
                                <div><b class="mr-1">{{ slotProps.option.UI }}</b> {{ slotProps.option.Unidad }}</div>
                            </div>
                        </template>
                        <template #chip="slotProps">
                          <b class="mr-1">{{ slotProps.value.UI }}</b> {{ slotProps.value.Unidad }}
                        </template>
                        <template #footer>
                            <div class="py-2 px-3">
                                <b>{{ objEvent.unidades ? objEvent.unidades.length : 0 }}</b> item{{ (objEvent.unidades ? objEvent.unidades.length : 0) > 1 ? 's' : '' }} selected.
                            </div>
                        </template>
                    </MultiSelect>
                    <small class="p-error" v-if="submitted && ((objEvent.unidades && objEvent.unidades.length == 0) || !objEvent.unidades)">Se requiere al menos una unidad.</small>
                  </div>
                  <div class="col-12 field" v-if="unidadesSite?.length > 0">
                    <label class="font-bold" for="CentrosCostos">Centros de costo</label>
                    <MultiSelect v-model="objEvent.CentrosCosto" :options="unidadesSite" optionLabel="Descripcion_CC" placeholder="Seleccionar centros de costos" display="chip" class="w-full" id="CentrosCosto" :filter="true" dataKey="Descripcion_CC"
                    :class="{ 'p-invalid': submitted && ((objEvent.CentrosCosto && objEvent.CentrosCosto.length == 0) || !objEvent.CentrosCosto) }"
                    :disabled="objEvent.Id_estatus == 12"
                    :filterFields="['Descripcion_CC']"
                    >
                        <template #footer>
                            <div class="py-2 px-3">
                                <b>{{ objEvent.CentrosCosto ? objEvent.CentrosCosto.length : 0 }}</b> item{{ (objEvent.CentrosCosto ? objEvent.CentrosCosto.length : 0) > 1 ? 's' : '' }} selected.
                            </div>
                        </template>
                    </MultiSelect>
                    <small class="p-error" v-if="submitted && ((objEvent.CentrosCosto && objEvent.CentrosCosto.length == 0) || !objEvent.CentrosCosto)">Se requiere al menos un centro de costo.</small>
                  </div>
                </div>
            </div>
            <DataTable
                :value="objEvent.empleados"
                dataKey="Matricula"
                responsiveLayout="scroll"
                class="p-datatable-sm"
                scrollHeight="300px"
                :rowClass="rowClass"
                >
                <template v-if="isAdministradorMantenimientos()" #header>
                    <div class="grid flex justify-content-end" v-if="objEvent.Id_estatus == 10">
                        <div class="col-3">
                            <Button class="p-button-sm" icon="pi pi-plus" label="Agregar personal" @click="showDialogEmpleados"/>
                        </div>
                    </div>
                </template>
                <template #empty> No se encontrarón registros. </template>
                <template #loading> Cargando datos. Espere por favor. </template>
                <Column field="Matricula" header="Matricula">
                  <template #body="slotProps">
                    <div :class="{'p-disabled' : slotProps.data.Id_estatus != 10}">
                      {{ slotProps.data.Matricula }}
                    </div>
                  </template>
                </Column>
                <Column header="Nombre">
                  <template #body="slotProps">
                    <div :class="{'p-disabled' : slotProps.data.Id_estatus != 10}">
                      {{ slotProps.data.Nombres }} {{ slotProps.data.Ap_pat }} {{ slotProps.data.Ap_mat }}
                    </div>
                  </template>
                </Column>
                <Column field="Puesto" header="Puesto">
                  <template #body="slotProps">
                    <div :class="{'p-disabled' : slotProps.data.Id_estatus != 10}">
                      {{ slotProps.data.Puesto }}
                    </div>
                  </template>
                </Column>
                <Column header="Chofer">
                  <template #body="slotProps">
                    <Checkbox v-model="slotProps.data.Es_chofer" :binary="true" :disabled="objEvent.Id_estatus != 10 || slotProps.data.Id_estatus != 10"/>
                  </template>
                </Column>
                <Column header="Pliego">
                  <template v-if="isAdministradorMantenimientos()" #header>
                    <Checkbox v-if="typeof objEvent.empleados.length != 'undefined' && objEvent.empleados.length > 0" v-model="pliegoSeleccionados" :binary="true" :disabled="objEvent.Id_estatus != 10" @change="selecccionarTodosPliego" class="mr-2"/>
                  </template>
                  <template #body="slotProps">
                    <Checkbox v-model="slotProps.data.Cobra_pliego" :binary="true" :disabled="objEvent.Id_estatus != 10 || slotProps.data.Id_estatus != 10" @change="changePliegoEmpleado"/>
                  </template>
                </Column>
                <Column v-if="objEvent.Id_estatus == 10 && isAdministradorMantenimientos()" header="">
                  <template #body="slotProps">
                    <Button :icon="slotProps.data.Id_estatus == 10 ? 'pi pi-minus' : 'pi pi-plus'" label="" style="width: 1rem; height: 1rem; padding: 1rem;" class="p-button-sm p-button-rounded p-button-outlined" @click="cambiarEstado(slotProps.data)"/>
                  </template>
                </Column>
                <template #footer>
                  <small class="p-error" v-if="submitted && ((objEvent.empleados && objEvent.empleados.filter(x => x.Id_estatus == 10).length == 0) || !objEvent.empleados)">Se requiere al menos un empleado.</small>
                </template>
            </DataTable>
          </BlockUI>
        </TabPanel>
        <TabPanel v-if="objEvent?.Id_mantenimiento" header="Equipos trabajados">
          <DataTable
                :value="objEvent.equipos_mantenimiento"
                dataKey="Id_equipo_mantenimiento"
                responsiveLayout="scroll"
                class="p-datatable-sm"
                scrollHeight="300px"
                >
                <template v-if="isAdministradorMantenimientos()" #header>
                    <div class="grid flex justify-content-end" v-if="objEvent.Id_mantenimiento">
                        <div class="col-3">
                            <Button class="p-button-sm" icon="pi pi-plus" label="Agregar equipos" @click="showDialogAgregarEquiposMantenimiento"/>
                        </div>
                    </div>
                </template>
                <template #empty> No se encontrarón registros. </template>
                <template #loading> Cargando datos. Espere por favor. </template>
                <Column field="MARCA" header="MARCA">
                  <template #body="{data}">
                    {{ data.MARCA }} {{ data.MODELO }}
                  </template>
                </Column>
                <Column field="SERIE" header="SERIE"></Column>
                <Column field="UNIDAD" header="UNIDAD"></Column>
                <Column field="IP" header="IP"></Column>
                <Column v-if="objEvent.Id_mantenimiento && isAdministradorMantenimientos()" header="">
                  <template #body="slotProps">
                    <Button icon="pi pi-minus" label="" style="width: 1rem; height: 1rem; padding: 1rem;" class="p-button-sm p-button-rounded p-button-outlined mr-1" @click="eliminarEquipoMantenimiento(slotProps.data)"/>
                    <Button icon="pi pi-pencil" label="" style="width: 1rem; height: 1rem; padding: 1rem;" class="p-button-sm p-button-rounded p-button-outlined" @click="showFormEquipoUniverso(slotProps.data)"/>
                  </template>
                </Column>
            </DataTable>
        </TabPanel>
      </TabView>
    <template #footer>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-text"
        @click="cancelarDialogo"
      />
      <Button v-if="objEvent.Id_estatus == 10 && isAdministradorMantenimientos()"
        label="Guardar"
        icon="pi pi-save"
        class="p-button-text"
        @click="guardarEvento"
      />
      <Button v-if="objEvent.Id_mantenimiento && objEvent.Id_estatus == 10 && isAdministradorMantenimientos()"
        label="Finalizar"
        icon="pi pi-verified"
        class=""
        @click="showFinalizar"
      />
    </template>
  </Dialog>

  <!-- Dialogo de empleados -->
  <Dialog
    :style="{ width: '45%' }"
    :visible="showEmpleados"
    :modal="true"
    class="p-fluid"
  >
    <template #header>
      <h3> Seleccionar empleados</h3>
    </template>

  <DataTable
      :value="empleados"
      v-model:selection="selectedEmpleados"
      dataKey="Matricula"
      responsiveLayout="scroll"
      scrollHeight="300px"
      class="p-datatable-sm"
      v-model:filters="filters"
      :globalFilterFields="['Nombres','Ap_pat','Ap_mat','Matricula','Puesto']"
      >
      <template #header>
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText type="text" v-model="filters['global'].value"  placeholder="Buscar..."/>
        </span>
      </template>
      <template #empty> No se encontrarón registros. </template>
      <template #loading> Cargando datos. Espere por favor. </template>
      <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
      <Column field="Matricula" header="Matricula"></Column>
      <Column header="Nombre">
        <template #body="slotProps">
          {{ slotProps.data.Nombres }} {{ slotProps.data.Ap_pat }} {{ slotProps.data.Ap_mat }}
        </template>
      </Column>
      <Column field="Puesto" header="Puesto"></Column>
  </DataTable>
    <template #footer>
      <Button
        label="Cerrar"
        icon="pi pi-times"
        class="p-button-text"
        @click="cancelarDialogoEmpleados"
      />
      <Button
        label="Agregar"
        icon="pi pi-check"
        class="p-button-text"
        @click="agregarEmpleados"
      />
    </template>
  </Dialog>

  <Dialog
    :style="{ width: '40%' }"
    :visible="displayFinalizar"
    :modal="true"
    class="p-fluid"
    :closable="false"
  >
    <template #header>
      <h3> Finalizar Mantenimiento</h3>
    </template>

    <div class="grid mt-2">
            <div class="col-6 flex align-items-center">
              <label class="text-lg" for="realizado_en_fecha">¿Se realizo en la fecha establecida?</label>
              <Checkbox id="realizado_en_fecha" class="ml-2" v-model="objEvent.Realizado_enfecha" :binary="true"/>
            </div>
            <div class="col-6 flex align-items-center justify-content-end" v-if="!objEvent.Realizado_enfecha">
              <label class="text-lg mr-2" for="fecha_realizado">Fecha de realización</label>
              <Calendar id="fecha_realizado" v-model="objEvent.Fecha_realizado"/>
            </div>
            <div class="col-12">
              <div class="flex justify-content-between">
                <div class="col-4">
                  <h5>Observaciones</h5>
                </div>
              </div>
              <Textarea v-model="objEvent.Observaciones" rows="5" cols="30" class="w-full" id="observaciones"/>
            </div>
      </div>

    <template #footer>
      <Button
        label="Cerrar"
        icon="pi pi-times"
        class="p-button-text"
        @click="cancelarDialogoFinalizar"
      />
      <Button
        label="Aceptar"
        icon="pi pi-check"
        class="p-button-text"
        @click="finalizarEvento"
      />
    </template>
  </Dialog>
  <ComponentBusquedaEquipo :displayComponent="displayAgregarEquipoMantenimiento" :unidadesMantenimiento="objEvent?.unidades_temp" @onClose="closeDialogEquipos" @onSelect="onSelectEquipos"/>
  <ComponentFormEquipoComputo :equipoFormulario="equipoUniversoSelected" :displayComponent="displayFormEquipoComputo" @onClose="onCloseFormEquipoUniverso" @onSave="onSaveFormEquipoUniverso"/>
</template>

<script>
import Srvr from "../service/Empleados";
import ServicioUnidades from "../service/Unidades";
import ServicioMantenimientos from "../service/Mantenimientos";
import ServicioEquiposComputo from "../service/EquiposComputo";
import Utilerias from '../utilidades/Utilerias'
import {FilterMatchMode} from 'primevue/api';
import {mapGetters} from 'vuex'
import ComponentBusquedaEquipo from "./ComponentBusquedaEquipo.vue";
import ComponentFormEquipoComputo from "./ComponentFormEquipoComputo.vue";
export default {
  components: {
    ComponentBusquedaEquipo,
    ComponentFormEquipoComputo
  },
  data() {
    return {
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      daysOfWeek: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'], // Nombres de los días de la semana
      calendarGrid: [], // Matriz bidimensional de los días del mes
      currentDate: new Date(),  // Fecha actual
      today: new Date(),  // Fecha actual
      objEvent: {unidades:[], empleados: [], Id_estatus : 10,equipos_mantenimiento:[]},
      showAgregar: false,
      modoEdicion: '',
      submitted: false,
      loading: false,
      showEmpleados: false,
      empleados: [],
      selectedEmpleados: [],
      unidades: [],
      mantenimientos: [],
      disabledDate: false,
      estatus: {
        "10": "bg-blue-100",
        "11": "bg-red-500 text-white",
        "12": "bg-green-500 text-white",
      },
      pliegoSeleccionados : false,
      displayFinalizar : false,
      displayAgregarEquipoMantenimiento: false,
      active: 0,
      unidadesSite: [],
      equipoUniversoSelected : null,
      displayFormEquipoComputo: false,
    };
  },
  computed: {
    
    ...mapGetters(["getUsuarioLogueado"]),
  },
  methods: {
    currentMonth() {
      // Obtén el nombre del mes actual
      const options = { month: 'long', year: 'numeric' };
      return this.currentDate.toLocaleDateString(undefined, options).toLocaleUpperCase();
    },
    prevMonth() {
      // Cambiar al mes anterior
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
      this.updateCalendarGrid();
    },
    nextMonth() {
      // Cambiar al siguiente mes
      this.currentDate.setMonth(this.currentDate.getMonth() + 1);
      this.updateCalendarGrid();
    },
    updateCalendarGrid() {
      // Calcula los días del mes actual y llena calendarGrid
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const firstDayOfMonth = new Date(year, month, 1).getDay();
      // const lastDayOfMonth = new Date(year, month, daysInMonth).getDay();
      const calendarGrid = [];
      let week = [];
  
      for (let day = 1; day <= daysInMonth + firstDayOfMonth; day++) {
        if (day > firstDayOfMonth) {
          week.push(day - firstDayOfMonth);
        } else {
          week.push('');
        }
  
        if (day % 7 === 0 || day === daysInMonth + firstDayOfMonth) {
          calendarGrid.push([...week]);
          week = [];
        }
      }
  
      this.calendarGrid = calendarGrid;
    },
    agregarEvento(fecha){
      if(!this.isAdministradorMantenimientos()){
        return;
      }
      if(fecha != null) this.objEvent.Fecha_mantenimiento = fecha;
      this.modoEdicion = 'Agregar';
      this.showAgregar = true;
      this.disabledDate = false;
      this.pliegoSeleccionados = false;
    },
    cancelarDialogo(){
      this.showAgregar = false;
      this.objEvent = {unidades:[], empleados: [], Id_estatus : 10,equipos_mantenimiento:[]};
      this.submitted = false;
      this.active = 0;
    },
    guardarEvento(){
      var t = this;
      t.submitted = true;
      if(t.objEvent.unidades.length == 0 || (t.objEvent.unidades.some(u => u.UI == "339001") && (!t.objEvent.CentrosCosto || t.objEvent.CentrosCosto?.length == 0)) || t.objEvent.empleados.filter(x => x.Id_estatus == 10).length == 0 || !t.objEvent.Fecha_mantenimiento){
        return; 
      }
      t.$confirm.require({
              message: '¿Está seguro que desea guardar estos datos?',
              header: 'Confirmacion',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                let utils =  new Utilerias();
                let mantenimiento = {Fecha_mantenimiento: utils.formateaFechaDATE(t.objEvent.Fecha_mantenimiento), Id_usuario_registro: t.getUsuarioLogueado.Usuario.Id_usuario, Id_usuario_mod: t.getUsuarioLogueado.Usuario.Id_usuario,empleados: [], unidades: []};
                
                for(let empleado in t.objEvent.empleados){
                  mantenimiento.empleados.push(
                    {
                      Matricula: t.objEvent.empleados[empleado].Matricula, 
                      Es_chofer: (typeof t.objEvent.empleados[empleado].Es_chofer != 'undefined' && t.objEvent.empleados[empleado].Es_chofer), 
                      Cobra_pliego: (typeof t.objEvent.empleados[empleado].Cobra_pliego != 'undefined' && t.objEvent.empleados[empleado].Cobra_pliego), 
                      Id_estatus : typeof t.objEvent.empleados[empleado].Id_estatus != 'undefined' ? t.objEvent.empleados[empleado].Id_estatus : 10
                    });
                }

                t.objEvent.unidades.forEach(unidad => {
                  if(unidad.UI == "339001"){
                    let ccs = t.objEvent.CentrosCosto.filter(cc => cc.UI == unidad.UI);
                    ccs.forEach(element => {
                      mantenimiento.unidades.push({
                        UI: element.UI,
                        Unidad : unidad.Unidad,
                        Descripcion_CC: element.Descripcion_CC
                      });
                    });
                  }else{
                    mantenimiento.unidades.push(unidad);
                  }
                });
                  // let { newData, index } = event;
                  var ctlSvr = new ServicioMantenimientos();

                  if(typeof t.objEvent.Id_mantenimiento != 'undefined' && t.objEvent.Id_mantenimiento > 0){
                    mantenimiento.Id_mantenimiento = t.objEvent.Id_mantenimiento;
                    ctlSvr.updateMantenimiento(t,mantenimiento).then((res) => {
                        if (res != null){
                             t.$toast.add({
                                severity: "success",
                                summary: "AVISO",
                                detail: "Los cambios se han guardado correctamente.",
                                life: 3000,
                                });
                            t.getMantenimientos();
                            t.cancelarDialogo();
                        }
                    });
                  }else{
                    ctlSvr.addMantenimiento(t,mantenimiento).then((res) => {
                        if (res != null){
                             t.$toast.add({
                                severity: "success",
                                summary: "AVISO",
                                detail: "Los cambios se han guardado correctamente.",
                                life: 3000,
                                });
                            t.getMantenimientos();
                            t.cancelarDialogo();
                        }
                    });
                  }
              },
              reject: () => {
              }
      });
    },
    getEmpleados(){
      var t = this;
      var ctlSvr = new Srvr();
      ctlSvr.getEmpleados(t).then((res) => {
          t.empleados = res;
      });
    },
    getEmpleadosMantenimiento(Id_mantenimiento){
      var t = this;
      var ctlSvr = new Srvr();
      ctlSvr.getEmpleadosMantenimiento(t,Id_mantenimiento).then((res) => {
          t.objEvent.empleados = res;
          // t.objEvent.empleados = [...t.objEvent.empleados.filter(x => x.Id_estatus == 1),...t.objEvent.empleados.filter(x => x.Id_estatus == 2)];
      });
    },
    getUnidades(){
      var t = this;
      var ctlSvr = new ServicioUnidades();
      ctlSvr.getUnidades(t).then((res) => {
          t.unidades = (res.Unidades).map(u => {
            return {
              UI: u.Unidad_informacion,
              Unidad: u.Descripcion_unidad_informacion,
            }
          });
      });
      
    },
    getCCs(UI){
      var t = this;
      var ctlSvr = new ServicioUnidades();
      ctlSvr.getUnidadesPorUI(t,UI).then((res) => {
          t.unidadesSite = (res).map(u => {
            return {
              UI: UI,
              Descripcion_CC: u.Descripcion_inventario
            }
          });
      });
      
    },
    getMantenimientos(){
      var t = this;
      let utils =  new Utilerias();
      var ctlSvr = new ServicioMantenimientos();
      ctlSvr.getMantenimientos(t).then((res) => {
          t.mantenimientos = res;
          t.mantenimientos.map(x => {x.Fecha_mantenimiento = utils.getDateFromWCF(x.Fecha_mantenimiento);})
      });
    },
    showDialogEmpleados(){
      this.showEmpleados = true;
      this.selectedEmpleados = [];
    },
    cancelarDialogoEmpleados(){
      this.showEmpleados = false;
    }, 
    agregarEmpleados(){
      let t = this;
      t.selectedEmpleados.forEach(element => {
        if(!t.objEvent.empleados.some(x => x.Matricula == element.Matricula)){
          t.objEvent.empleados.push({Id_estatus : 10, ...element});
        }
      });
    },
    getDateFromMonth(day){
      let dayofmonth = new Date(this.currentDate);
      dayofmonth.setDate(day);
      return dayofmonth;
    },
    obtenerMantenimientosDelDia(day){
      let actual = this.getDateFromMonth(day);
      actual.setHours(0,0,0,0);
      let mantenimientos_dia = this.mantenimientos.filter((mantenimiento) => {
        let fecha1 = mantenimiento.Fecha_mantenimiento;
        fecha1.setHours(0,0,0,0);


        return fecha1.getTime() === actual.getTime();
      });
      return mantenimientos_dia;
    },
    isToday(day){
      let actual = this.getDateFromMonth(day);
      actual.setHours(0,0,0,0);
      let today1 = this.today.setHours(0,0,0,0);
      return today1 == actual.getTime();
    },
    modificarEvento(evento){
      if(evento != null){
        this.objEvent = {...evento};
        this.objEvent.empleados = [];
        this.getEmpleadosMantenimiento(evento.Id_mantenimiento);
        this.verificarUnidades();
        this.formatUnidadesFromDB();
        if(this.objEvent.Fecha_realizado){
          let utils =  new Utilerias();
          this.objEvent.Fecha_realizado = utils.getDateFromWCF(this.objEvent.Fecha_realizado);
        }
      } 
      this.pliegoSeleccionados = false;
      this.modoEdicion = 'Modificar';
      this.showAgregar = true;
      this.disabledDate = true;
    },
    cambiarEstado(data){
      switch (data.Id_estatus){
        case 10:
          data.Id_estatus = 11;
          this.reordenar_empleados(data.Matricula, false);
        break;
        case 11:
           data.Id_estatus = 10;
          this.reordenar_empleados(data.Matricula, true);

        break;

      }

    },
    reordenar_empleados(matricula, estado){
      
      // Encuentra el índice del elemento que coincide con la propiedad
      var indiceElemento = this.objEvent.empleados.findIndex(function(elemento) {
        return elemento.Matricula === matricula;
      });

      // Verifica si se encontró un elemento con la propiedad deseada
      if (indiceElemento !== -1) {
        // Extrae el elemento encontrado
        var elementoEncontrado = this.objEvent.empleados.splice(indiceElemento, 1)[0];

        if(estado){
          let activos = this.objEvent.empleados.filter(x => x.Id_estatus == 10);
          let inactivos = this.objEvent.empleados.filter(x => x.Id_estatus == 11);
          activos.push(elementoEncontrado);
          if(this.objEvent.Id_mantenimiento){
            this.objEvent.empleados =  [...activos, ...inactivos];
          }

        }else{
          if(this.objEvent.Id_mantenimiento){
            this.objEvent.empleados.push(elementoEncontrado);
          }
        }
        // Añade el elemento al final del array
      } else {
        console.log("El elemento con la propiedad deseada no se encontró en el array.");
      }
    },
    rowClass(data){
      return [{ 'bg-danger': data.Id_estatus == 11 }];
    },
    finalizarEvento(){
      var t = this;
      t.submitted = true;
      if(t.objEvent.unidades.length == 0 || t.objEvent.empleados.filter(x => x.Id_estatus == 10).length == 0 || !t.objEvent.Fecha_mantenimiento){
        return; 
      }
      // if(!this.comprobarChofer()) return false;
      if(!t.objEvent.Realizado_enfecha && !t.objEvent.Fecha_realizado){
        t.$toast.add({
          severity: "warn",
          summary: "AVISO",
          detail: "Se requiere una fecha de realización.",
          life: 3000,
        });
        return;
      }
      // if(!this.comprobarAsistencia()) return false;

      t.$confirm.require({
              message: '¿Está seguro que desea finalizar este mantenimiento?',
              header: 'Confirmacion',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                let utils =  new Utilerias();
                let mantenimiento = {
                  Fecha_mantenimiento: utils.formateaFechaDATE(t.objEvent.Fecha_mantenimiento),
                  Id_usuario_mod: t.getUsuarioLogueado.Usuario.Id_usuario,
                  empleados: [], 
                  unidades: [],
                  Realizado_enfecha : t.objEvent.Realizado_enfecha,
                  Fecha_realizado : t.objEvent.Fecha_realizado ? utils.formateaFechaDATE(t.objEvent.Fecha_mantenimiento) : null,
                  Observaciones : t.objEvent.Observaciones,
                };
                mantenimiento.Id_mantenimiento = t.objEvent.Id_mantenimiento;
                
                for(let empleado in t.objEvent.empleados){
                  mantenimiento.empleados.push(
                    {
                      Matricula: t.objEvent.empleados[empleado].Matricula, 
                      Es_chofer: (typeof t.objEvent.empleados[empleado].Es_chofer != 'undefined' && t.objEvent.empleados[empleado].Es_chofer), 
                      Cobra_pliego: (typeof t.objEvent.empleados[empleado].Cobra_pliego != 'undefined' && t.objEvent.empleados[empleado].Cobra_pliego), 
                      Id_estatus : typeof t.objEvent.empleados[empleado].Id_estatus != 'undefined' ? t.objEvent.empleados[empleado].Id_estatus : 10,
                    });
                }

                t.objEvent.unidades.forEach(unidad => {
                  if(unidad.UI == "339001"){
                    let ccs = t.objEvent.CentrosCosto.filter(cc => cc.UI == unidad.UI);
                    ccs.forEach(element => {
                      mantenimiento.unidades.push({
                        UI: element.UI,
                        Unidad : unidad.Unidad,
                        Descripcion_CC: element.Descripcion_CC
                      });
                    });
                  }else{
                    mantenimiento.unidades.push(unidad);
                  }
                });
                  // let { newData, index } = event;
                  var ctlSvr = new ServicioMantenimientos();

                    ctlSvr.finalizarMantenimiento(t,mantenimiento).then((res) => {
                        if (res != null){
                             t.$toast.add({
                                severity: "success",
                                summary: "AVISO",
                                detail: "Los cambios se han guardado correctamente.",
                                life: 3000,
                                });
                            t.getMantenimientos();
                            t.cancelarDialogo();
                            t.cancelarDialogoFinalizar();
                        }
                    });
              },
              reject: () => {
              }
      });
    },
    selecccionarTodosPliego(){
      this.objEvent.empleados.map(x => x.Cobra_pliego = this.pliegoSeleccionados);
    },
    changePliegoEmpleado(){
      this.pliegoSeleccionados = false;
    },
    eliminarMantenimiento(){
      let t = this;
      t.$confirm.require({
              message: '¿Está seguro que desea eliminar este mantenimiento?',
              header: 'Confirmacion',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                var ctlSvr = new ServicioMantenimientos();

                    ctlSvr.eliminarMantenimiento(t,t.objEvent.Id_mantenimiento).then((res) => {
                        if (res != null){
                             t.$toast.add({
                                severity: "success",
                                summary: "AVISO",
                                detail: "Se ha eliminado el registro.",
                                life: 3000,
                                });
                            t.getMantenimientos();
                            t.cancelarDialogo();
                        }
                    });
              },
              reject: () => {
              }
      });
    },
    showFinalizar(){
      this.displayFinalizar = true;
    },
    cancelarDialogoFinalizar(){
      this.displayFinalizar = false;
    },
    showEquiposMantenimiento(){

    },
    closeDialogEquipos(){
      this.displayAgregarEquipoMantenimiento = false;

    },
    showDialogAgregarEquiposMantenimiento(){
      this.displayAgregarEquipoMantenimiento = true;
    },
    onSelectEquipos(equipos){
      let t =  this;
      if(equipos?.length){
        let equiposPorAgregar = equipos.filter(e => !t.objEvent.equipos_mantenimiento.some(f => f.Id_equipo_tabla == e.Id_equipo_tabla));
        if(equiposPorAgregar.length > 0){
            let servicioMantenimientos = new ServicioMantenimientos();
            let lista = equipos.map(e => {
              return {
                Id_equipo : e.Id_equipo,
                Id_mantenimiento : t.objEvent.Id_mantenimiento,
                Catalogo : e.Catalogo,
              }
            })
            servicioMantenimientos.addMantenimientoEquipos(t, lista).then((res) => {
              if(res){
                t.$toast.add({
                  severity: "success",
                  summary: "AVISO",
                  detail: "Los equipos se agregaron correctamente.",
                  life: 3000,
                });
                t.getMantenimientoEquipos();
              }
            });
        }else{
          t.$toast.add({
            severity: "warn",
            summary: "AVISO",
            detail: "Los equipos seleccionados ya fueron agregados anteriormente.",
            life: 3000,
          });
        }
      }
    },
    getMantenimientoEquipos(){
      let t = this;
      if(t.objEvent.Id_mantenimiento){
        let servicioMantenimientos = new ServicioMantenimientos();
        servicioMantenimientos.getMantenimientoEquipos(t,t.objEvent.Id_mantenimiento).then((res) => {
          if(res){
            t.objEvent.equipos_mantenimiento = res;
            t.objEvent.equipos_mantenimiento.forEach(element => {
                    element.Id_equipo_tabla = `${element.Id_equipo}_${element.Catalogo}`;
            });
          }
        });
      }
    },
    eliminarEquipoMantenimiento(data){
      let t = this;
      t.$confirm.require({
              message: '¿Está seguro que desea eliminar este equipo del mantenimiento?',
              header: 'Confirmacion',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                let servicioMantenimientos = new ServicioMantenimientos();
                servicioMantenimientos.deleteMantenimientoEquipo(t,data.Id_mantenimiento_equipo).then((res) => {
                  if(res){
                    t.getMantenimientoEquipos();
                  }
                });
              },
              reject: () => {
              }
      });
    },
    tabChange(index){
      if(index == 1){
        this.getMantenimientoEquipos();
      }
    },
    verificarUnidades(){
      let t = this;
      if(t.objEvent?.unidades?.length > 0){
        let delegacion = t.objEvent.unidades.find(u => u.UI == "339001");
        if(delegacion){
          t.getCCs(delegacion.UI);
        }else{
          t.objEvent.CentrosCosto = t.objEvent.CentrosCosto?.filter(cc => cc.UI != "339001");
          t.unidadesSite = [];
        }
      }else{
        t.unidadesSite = [];
        t.objEvent.CentrosCosto = [];
      }
    },
    formatUnidadesFromDB(){
      let t = this;
      let cc_group = [];
      let unidades_temp = [];
      let ccs_temp = [];

      if(t.objEvent?.unidades?.length > 0){

        t.objEvent.unidades_temp = [...t.objEvent.unidades];
        t.objEvent.unidades.forEach(u => {
            if(!cc_group[u.UI]){
              cc_group[u.UI] = []
            }
  
            cc_group[u.UI].push(u);
          });
  
          cc_group.forEach((value) => {
            unidades_temp.push({
              UI: value[0].UI,
              Unidad: value[0].Unidad,
            });

            value.forEach(cc => {
              if(cc.Descripcion_CC){
                ccs_temp.push({
                  UI: cc.UI,
                  Descripcion_CC: cc.Descripcion_CC,
                });
              }
            });
          });
      }
      t.objEvent.unidades = t.unidades.filter(u => unidades_temp.some(ut => ut.UI == u.UI));
      t.objEvent.CentrosCosto = ccs_temp;
    },
    showFormEquipoUniverso(equipo){
      let t = this;
      if(equipo){
        let servicioEquiposComputo = new ServicioEquiposComputo();
        switch(equipo.Catalogo){
          case "Equipos_computo":
            servicioEquiposComputo.getEquipoComputo(t,equipo.Id_equipo).then(res => {
              if(res && res.Id_equipo_computo){
                this.showFormEquipoComputo(res);
              }else{
                this.$toast.add({
                  severity: "warn",
                  summary: "AVISO",
                  detail: "No se pudo obtener los datos correctamente.",
                  life: 3000,
                });
              }
            });
          break;
          default:
            this.$toast.add({
              severity: "warn",
              summary: "AVISO",
              detail: "Este equipo no esta en los catalogos validos.",
              life: 3000,
            });
          break;
        }
      }

    },

    showFormEquipoComputo(equipoComputo){
      this.equipoUniversoSelected = {...equipoComputo};
      this.displayFormEquipoComputo = true;
    },
    onCloseFormEquipoUniverso(){
      this.displayFormEquipoComputo = false;
      this.equipoUniversoSelected = null;
    },
    onSaveFormEquipoUniverso(){
      this.displayFormEquipoComputo = false;
      this.equipoUniversoSelected = null;
      this.getMantenimientoEquipos();
    },
    isAdministradorMantenimientos(){
        let util = new Utilerias();
        return util.isPermiso("ADMINISTRAR_MANTENIMIENTOS") == true || util.isAdmin() || util.isCategoria("COORDINADOR DE SOPORTE TECNICO");
    }
    
  },
  created() {
    // Inicializa calendarGrid al crear el componente
    this.updateCalendarGrid();
  },
  mounted(){
    this.getEmpleados();
    this.getUnidades();
    this.getMantenimientos();
  }
};
</script>

<style scss>
  .week-container{
  display: flex;
  width: 100%;
  }
  .day-container{
  width: 14.28%;
  height: 15rem;
  border: 1px solid #DEDEDE;
  }

  .header-week-container{
  display: flex;
  border: 1px solid #DEDEDE;
  }
  .header-day-container{
  width: 14.28%;
  border: 1px solid #DEDEDE;
  }

  .day-container + .day-container,.header-day-container + .header-day-container {
  border-left: none; /* Elimina el borde izquierdo de las celdas adyacentes */
  }

  .week-container + .week-container .day-container, .header-week-container + .header-week-container .header-day-container {
  border-top: none; /* Elimina el borde superior de las celdas en filas adyacentes */
  }

  .header-week-container{
      border-bottom: none;
  }

  .bg-danger{
    color: red !important;
    font-weight: 500;
  }
  .scrolling-text{
      white-space: nowrap;
      overflow: ellipsis;
      width: 100%;
  }

  .scrolling-text-animation {
    animation: scrollText 5s linear infinite;
  }

  @keyframes scrollText {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  .p-blockui{
    background-color: transparent !important;
  }
</style>